(function () {
  var continueShoppingStorageKey = 'cwt-continue-shopping-url';

  function isCatalogPath(pathname) {
    return pathname === '/search' || pathname === '/collections' || pathname.indexOf('/collections/') === 0;
  }

  function storeCurrentCatalogLocation() {
    if (!isCatalogPath(window.location.pathname)) return;

    try {
      window.sessionStorage.setItem(continueShoppingStorageKey, window.location.href);
    } catch (error) {}
  }

  function patchContinueShoppingLink() {
    var link = document.querySelector('.product-cart-actions__continue');
    if (!link) return;

    var candidates = [document.referrer];

    try {
      candidates.push(window.sessionStorage.getItem(continueShoppingStorageKey));
    } catch (error) {}

    for (var index = 0; index < candidates.length; index += 1) {
      if (!candidates[index]) continue;

      try {
        var candidate = new URL(candidates[index]);
        if (candidate.origin !== window.location.origin || !isCatalogPath(candidate.pathname)) continue;
        link.setAttribute('href', candidate.pathname + candidate.search + candidate.hash);
        return;
      } catch (error) {}
    }
  }

  function watchCatalogProductLinks() {
    document.addEventListener('click', function (event) {
      if (!isCatalogPath(window.location.pathname)) return;
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('a[href*="/products/"]')) return;
      storeCurrentCatalogLocation();
    });
  }

  function routeAllProductsToSearch() {
    if (window.location.pathname !== '/collections/all' || window.location.search) {
      return;
    }

    window.location.replace('/search?type=product&q=');
  }

  function patchLocalWebsiteLinks() {
    var localHosts = ['127.0.0.1', 'localhost'];

    if (!localHosts.includes(window.location.hostname)) {
      return;
    }

    var siteOrigin = getLocalSiteOrigin(localHosts);

    if (!siteOrigin) {
      return;
    }

    document.querySelectorAll('[data-cwt-site-path]').forEach(function (link) {
      var path = link.getAttribute('data-cwt-site-path') || '/';
      link.setAttribute('href', new URL(path, siteOrigin).toString());
    });
  }

  function getLocalSiteOrigin(localHosts) {
    var searchParams = new URLSearchParams(window.location.search);
    var hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    var candidates = [hashParams.get('cwt_site_url'), searchParams.get('cwt_site_url')];

    try {
      var referrer = new URL(document.referrer);
      if (localHosts.includes(referrer.hostname) && referrer.origin !== window.location.origin) {
        candidates.push(referrer.origin);
      }
    } catch (error) {}

    try {
      candidates.push(window.localStorage && window.localStorage.getItem('cwt_site_url'));
    } catch (error) {}

    for (var index = 0; index < candidates.length; index += 1) {
      if (!candidates[index]) continue;

      try {
        var candidate = new URL(candidates[index]);
        if (!localHosts.includes(candidate.hostname)) continue;
        try {
          if (window.localStorage) {
            window.localStorage.setItem('cwt_site_url', candidate.origin);
          }
        } catch (error) {}
        return candidate.origin;
      } catch (error) {}
    }

    return '';
  }

  function patchFooter() {
    var footerContent = document.querySelector('footer .footer-content');

    if (!footerContent || footerContent.dataset.citywidePolished === 'true') {
      return;
    }

    var text = footerContent.textContent || '';

    if (!text.includes('Join our email list')) {
      return;
    }

    var heading = footerContent.querySelector('h2, h3, h4');
    var paragraph = footerContent.querySelector('p');

    if (heading) {
      heading.textContent = 'Deals and restock reminders';
    }

    if (paragraph) {
      paragraph.textContent = 'Get useful store updates, product availability notes and supply offers.';
    }

    var links = document.createElement('nav');
    links.className = 'cwt-native-footer-links';
    links.setAttribute('aria-label', 'Footer store links');
    links.innerHTML = [
      '<div><h3>Shop</h3><a href="/search?type=product&q=">All products</a><a href="/search?type=product&q=*&filter.p.tag=collection%3APrinter%20Consumables">Toner and ink</a><a href="/search?type=product&q=*&filter.p.tag=collection%3APrinters">Printers</a><a href="/search?type=product&q=*&filter.p.tag=collection%3ANetworking%20%26%20Wi-Fi">Networking &amp; Wi-Fi</a></div>',
      '<div><h3>Help</h3><a href="/pages/contact">Contact store support</a><a href="/policies/shipping-policy">Shipping</a><a href="/policies/refund-policy">Returns</a><a href="/policies/privacy-policy">Privacy</a></div>'
    ].join('');

    footerContent.appendChild(links);
    footerContent.dataset.citywidePolished = 'true';
  }

  function setCitywideCartCount(count) {
    var cartLink = document.querySelector('.cwt-shop-cart');

    if (!cartLink) {
      return;
    }

    var badge = cartLink.querySelector('span');

    if (count > 0 && !badge) {
      badge = document.createElement('span');
      cartLink.appendChild(badge);
    }

    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count <= 0;
    }

    cartLink.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' items' : 'Cart');
  }

  function updateEmptyCartConversion(itemCount) {
    var emptyCart = document.querySelector('.cwt-empty-cart');

    if (!emptyCart) {
      return;
    }

    var postAdd = emptyCart.querySelector('.cwt-empty-cart__post-add');
    var defaultActions = emptyCart.querySelector(':scope > .cwt-empty-cart__actions');
    var reassurance = emptyCart.querySelector(':scope > .cwt-empty-cart__reassurance');
    var heading = document.querySelector('.cart-page--empty .cart-title h1');
    var hasItems = itemCount > 0;

    if (postAdd) {
      postAdd.hidden = !hasItems;
    }

    if (defaultActions) {
      defaultActions.hidden = hasItems;
    }

    if (reassurance) {
      reassurance.hidden = hasItems;
    }

    if (heading) {
      if (!heading.dataset.cwtEmptyLabel) {
        heading.dataset.cwtEmptyLabel = heading.textContent.trim();
      }

      heading.textContent = hasItems ? 'Ready to check out?' : heading.dataset.cwtEmptyLabel;
    }
  }

  function showCitywideCartHandoff() {
    var handoff = document.querySelector('.cwt-cart-handoff');

    if (!handoff) {
      handoff = document.createElement('aside');
      handoff.className = 'cwt-cart-handoff';
      handoff.setAttribute('aria-label', 'Cart updated');
      handoff.setAttribute('aria-live', 'polite');
      handoff.innerHTML = [
        '<button class="cwt-cart-handoff__close" type="button" aria-label="Dismiss cart update">&times;</button>',
        '<p><strong>Added to your cart</strong><span>Ready when you are.</span></p>',
        '<div class="cwt-cart-handoff__actions">',
        '<a class="cwt-cart-handoff__checkout" href="/checkout">Go to checkout</a>',
        '<a class="cwt-cart-handoff__cart" href="/cart">View cart</a>',
        '</div>',
      ].join('');

      handoff.querySelector('.cwt-cart-handoff__close').addEventListener('click', function () {
        handoff.hidden = true;
      });
      document.body.appendChild(handoff);
    }

    handoff.hidden = false;
  }

  function setAddButtonText(button, text) {
    if (!button) {
      return;
    }

    var label = button.querySelector('.add-to-cart-text__content > span > span');

    if (label) {
      label.textContent = text;
      return;
    }

    button.textContent = text;
  }

  function refreshCitywideCartCount() {
    return fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_url ? window.Theme.routes.cart_url : '/cart') + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          setCitywideCartCount(cart.item_count);
          markProductsInCart(cart);
          updateEmptyCartConversion(cart.item_count);
        }

        return cart;
      })
      .catch(function () {});
  }

  var citywideCartRequestQueue = Promise.resolve();
  var citywideCartVariantRequests = {};

  function getCitywideCartAddUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) {
      return window.Theme.routes.cart_add_url;
    }

    return '/cart/add.js';
  }

  function getCitywideCartChangeUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) {
      return window.Theme.routes.cart_change_url;
    }

    return '/cart/change.js';
  }

  function getCitywideCartVariantId(form) {
    var variantInput = form && form.querySelector('input[name="id"]');

    return variantInput && variantInput.value ? String(variantInput.value) : '';
  }

  function markAddFormPending(form) {
    if (!form) {
      return;
    }

    var button = form.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');
    var card = form.closest('.product-grid__item, .product-card, .product-card__content');

    if (card) {
      card.classList.add('cwt-product-cart-pending');
    }

    if (button) {
      if (!button.hasAttribute('data-cwt-original-label')) {
        button.setAttribute('data-cwt-original-label', button.getAttribute('aria-label') || '');
      }

      button.classList.add('cwt-add-button--pending');
      button.dataset.cwtPendingSince = String(Date.now());
      setAddButtonText(button, 'Adding');
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-label', 'Adding to cart');
      button.removeAttribute('title');
    }
  }

  function markAddFormBusy(form) {
    if (!form) {
      return;
    }

    var button = form.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');

    if (!button) {
      return;
    }

    if (!button.hasAttribute('data-cwt-original-label')) {
      button.setAttribute('data-cwt-original-label', button.getAttribute('aria-label') || '');
    }

    button.classList.add('cwt-add-button--busy');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-label', 'Updating cart');
    button.removeAttribute('title');
  }

  function clearAddFormBusy(form) {
    if (!form) {
      return;
    }

    var button = form.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');

    if (button) {
      button.classList.remove('cwt-add-button--busy');
      button.removeAttribute('aria-busy');
    }
  }

  function enqueueCitywideCartRequest(variantId, form, requestCallback) {
    if (!variantId || citywideCartVariantRequests[variantId]) {
      return;
    }

    citywideCartVariantRequests[variantId] = true;
    markAddFormBusy(form);

    citywideCartRequestQueue = citywideCartRequestQueue
      .catch(function () {})
      .then(requestCallback)
      .catch(function () {
        refreshCitywideCartCount();
      })
      .finally(function () {
        delete citywideCartVariantRequests[variantId];
        clearAddFormBusy(form);
        labelCitywideAddButtons();
        window.setTimeout(refreshCitywideCartCount, 250);
      });
  }

  function addAddFormToCart(form) {
    if (!form) {
      return;
    }

    var variantId = getCitywideCartVariantId(form);

    if (!variantId || citywideCartVariantRequests[variantId]) {
      return;
    }

    enqueueCitywideCartRequest(variantId, form, function () {
      return fetch(getCitywideCartAddUrl(), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add item to cart.');
        }

        return response.json();
      }).then(function () {
        return refreshCitywideCartCount();
      }).then(function () {
        showCitywideCartHandoff();
        document.dispatchEvent(new CustomEvent('cart:change'));
      });
    });
  }

  function markAddFormRemoving(form) {
    if (!form) {
      return;
    }

    var button = form.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');

    if (!button) {
      return;
    }

    button.classList.remove('cwt-add-button--pending');
    button.classList.remove('cwt-add-button--in-cart');
    button.classList.add('cwt-add-button--removing');
    button.setAttribute('aria-pressed', 'false');
    setAddButtonText(button, 'Removing');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-label', 'Removing from cart');
    button.removeAttribute('title');
  }

  function removeAddFormFromCart(form) {
    if (!form) {
      return;
    }

    var variantId = getCitywideCartVariantId(form);

    if (!variantId) {
      refreshCitywideCartCount();
      return;
    }

    if (citywideCartVariantRequests[variantId]) {
      return;
    }

    enqueueCitywideCartRequest(variantId, form, function () {
      return fetch(getCitywideCartChangeUrl(), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0,
        }),
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to remove item from cart.');
        }

        return response.json();
      }).then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          setCitywideCartCount(cart.item_count);
          markProductsInCart(cart);
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
          return;
        }

        refreshCitywideCartCount();
      });
    });
  }

  function handleCitywideCartToggleClick(event) {
    var button = event.currentTarget;

    if (!button) {
      return;
    }

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    var form = button.closest('form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    var variantId = getCitywideCartVariantId(form);

    if (!variantId || citywideCartVariantRequests[variantId]) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.classList.contains('cwt-add-button--in-cart')) {
      removeAddFormFromCart(form);
      return;
    }

    addAddFormToCart(form);
  }

  function bindCitywideCartToggle(button) {
    if (!button || button.dataset.citywideCartToggleBound === 'true') {
      return;
    }

    button.dataset.citywideCartToggleBound = 'true';
    button.addEventListener('click', handleCitywideCartToggleClick, true);
    button.addEventListener('pointerdown', handleCitywideCartToggleClick, true);
    button.addEventListener('keydown', handleCitywideCartToggleClick, true);
  }

  function labelCitywideAddButtons() {
    document.querySelectorAll('.add-to-cart-button, .quick-add__button').forEach(function (button) {
      bindCitywideCartToggle(button);

      if (button.classList.contains('cwt-add-button--busy')) {
        button.setAttribute('aria-label', 'Updating cart');
        button.removeAttribute('title');
        return;
      }

      if (button.classList.contains('cwt-add-button--in-cart')) {
        setAddButtonText(button, '✓ In cart');
        button.setAttribute('aria-label', 'In cart');
        button.removeAttribute('title');
        return;
      }

      if (button.classList.contains('cwt-add-button--removing')) {
        setAddButtonText(button, 'Removing');
        button.setAttribute('aria-label', 'Removing from cart');
        button.removeAttribute('title');
        return;
      }

      if (button.classList.contains('cwt-add-button--pending')) {
        setAddButtonText(button, 'Adding');
        button.setAttribute('aria-label', 'Adding to cart');
        button.removeAttribute('title');
        return;
      }

      setAddButtonText(button, 'Add to cart');

      if (!button.getAttribute('aria-label')) {
        button.setAttribute('aria-label', 'Add to cart');
      }

      button.removeAttribute('title');
    });
  }

  function markProductsInCart(cart) {
    var variantIds = {};

    (cart.items || []).forEach(function (item) {
      if (item && item.variant_id) {
        variantIds[String(item.variant_id)] = true;
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var button = form.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');
      var card = form.closest('.product-grid__item, .product-card, .product-card__content');
      var isInCart = variantInput && variantIds[String(variantInput.value)];

    if (card) {
      card.classList.toggle('cwt-product-in-cart', !!isInCart);
      card.classList.remove('cwt-product-cart-pending');
    }

      if (!button) {
        return;
      }

      button.classList.remove('cwt-add-button--pending');
      button.classList.remove('cwt-add-button--removing');
      delete button.dataset.cwtPendingSince;
      button.classList.toggle('cwt-add-button--in-cart', !!isInCart);
      button.setAttribute('aria-pressed', isInCart ? 'true' : 'false');

      if (isInCart) {
        if (!button.hasAttribute('data-cwt-original-label')) {
          button.setAttribute('data-cwt-original-label', button.getAttribute('aria-label') || '');
        }

        setAddButtonText(button, '✓ In cart');
        button.setAttribute('aria-label', 'In cart');
        button.removeAttribute('title');
      } else {
        if (button.getAttribute('data-added') === 'true') {
          button.classList.add('cwt-add-button--removing');
          setAddButtonText(button, 'Removing');
          button.setAttribute('aria-label', 'Removing from cart');
          button.removeAttribute('title');

          window.setTimeout(function () {
            if (button.classList.contains('cwt-add-button--in-cart')) {
              return;
            }

            button.removeAttribute('data-added');
            button.classList.remove('cwt-add-button--removing');
            setAddButtonText(button, 'Add to cart');

            if (button.hasAttribute('data-cwt-original-label')) {
              var delayedOriginalLabel = button.getAttribute('data-cwt-original-label');

              if (delayedOriginalLabel) {
                button.setAttribute('aria-label', delayedOriginalLabel);
              } else {
                button.removeAttribute('aria-label');
              }
            }

            button.removeAttribute('title');
          }, 360);
        } else {
          button.removeAttribute('data-added');
        }

        setAddButtonText(button, 'Add to cart');

        if (button.hasAttribute('data-cwt-original-label')) {
          var originalLabel = button.getAttribute('data-cwt-original-label');

          if (originalLabel) {
            button.setAttribute('aria-label', originalLabel);
          } else {
            button.removeAttribute('aria-label');
          }
        }

        button.removeAttribute('title');
      }
    });

    labelCitywideAddButtons();
  }

  function watchCitywideCartCount() {
    refreshCitywideCartCount();

    var observedResultsList;
    var productGridObserver = new MutationObserver(function () {
      window.clearTimeout(productGridObserver.timeout);
      productGridObserver.timeout = window.setTimeout(refreshCitywideCartCount, 160);
    });

    function watchProductGrid() {
      var resultsList = document.querySelector('#ResultsList');

      if (!resultsList || resultsList === observedResultsList) {
        return;
      }

      observedResultsList = resultsList;
      productGridObserver.disconnect();
      productGridObserver.observe(resultsList, {
        childList: true,
        subtree: true,
      });
    }

    watchProductGrid();

    ['cart:update', 'cart:change', 'cart:refresh', 'cart:lines:update'].forEach(function (eventName) {
      document.addEventListener(eventName, refreshCitywideCartCount);
    });

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise
          .then(function (payload) {
            var itemCount = payload && payload.detail && payload.detail.itemCount;
            if (typeof itemCount === 'number') {
              setCitywideCartCount(itemCount);
              return;
            }

            refreshCitywideCartCount();
          })
          .catch(refreshCitywideCartCount);
        return;
      }

      refreshCitywideCartCount();
    });

    document.addEventListener('submit', function (event) {
      if (event.target && event.target.matches('form[action*="/cart/add"]')) {
        var submitButton = event.target.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');

        event.preventDefault();
        event.stopPropagation();

        if (submitButton && submitButton.classList.contains('cwt-add-button--in-cart')) {
          removeAddFormFromCart(event.target);
          return;
        }

        addAddFormToCart(event.target);
      }
    });

    document.addEventListener('click', function (event) {
      watchProductGrid();

      if (event.target && event.target.closest('.add-to-cart-button, .quick-add__button, add-to-cart-component')) {
        var addForm = event.target.closest('form[action*="/cart/add"]');
        var addButton = addForm && addForm.querySelector('.quick-add__button, .add-to-cart-button, button[name="add"]');

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (addButton && addButton.classList.contains('cwt-add-button--in-cart')) {
          removeAddFormFromCart(addForm);
          return;
        }

        addAddFormToCart(addForm);
      }

      if (
        event.target &&
        event.target.closest('.cart-items__remove, cart-quantity-selector-component, .quantity-selector')
      ) {
        window.setTimeout(refreshCitywideCartCount, 1100);
      }
    }, true);
  }

  function trapDesktopSidebarWheel() {
    var sidebar = document.querySelector('.cwt-search-results-layout > .cwt-search-sidebar');

    if (!sidebar || sidebar.dataset.citywideWheelTrap === 'true') {
      return;
    }

    sidebar.dataset.citywideWheelTrap = 'true';

    sidebar.addEventListener('wheel', function (event) {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        return;
      }

      var maxScrollTop = sidebar.scrollHeight - sidebar.clientHeight;
      var isScrollingUp = event.deltaY < 0;
      var isScrollingDown = event.deltaY > 0;
      var pageScroller = document.scrollingElement || document.documentElement;
      var maxPageScrollTop = pageScroller.scrollHeight - window.innerHeight;

      if ((isScrollingUp && sidebar.scrollTop <= 0) || (isScrollingDown && sidebar.scrollTop >= maxScrollTop - 1)) {
        if ((isScrollingUp && window.scrollY > 0) || (isScrollingDown && window.scrollY < maxPageScrollTop - 1)) {
          event.preventDefault();
          event.stopPropagation();
          window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
        }

        return;
      }

      event.preventDefault();
      event.stopPropagation();
      sidebar.scrollTop = Math.max(0, Math.min(maxScrollTop, sidebar.scrollTop + event.deltaY));
    }, { passive: false });
  }

  function updateSearchSidebarViewportHeight() {
    var sidebar = document.querySelector('.cwt-search-results-layout > .cwt-search-sidebar');

    if (!sidebar) {
      return;
    }

    if (!window.matchMedia('(min-width: 990px)').matches) {
      sidebar.style.removeProperty('max-height');
      return;
    }

    var rect = sidebar.getBoundingClientRect();
    var stickyTop = 104;
    var bottomGap = 16;
    var visibleTop = Math.max(rect.top, stickyTop);
    var availableHeight = Math.max(360, Math.floor(window.innerHeight - visibleTop - bottomGap));

    sidebar.style.setProperty('max-height', availableHeight + 'px', 'important');
  }

  function scheduleSearchSidebarViewportHeight() {
    if (window.citywideSearchSidebarHeightFrame) {
      return;
    }

    window.citywideSearchSidebarHeightFrame = window.requestAnimationFrame(function () {
      window.citywideSearchSidebarHeightFrame = null;
      updateSearchSidebarViewportHeight();
      window.setTimeout(updateSearchSidebarViewportHeight, 160);
    });
  }

  function formatMoney(cents) {
    var number = Number(cents);

    if (!Number.isFinite(number)) {
      return '';
    }

    if (number >= 1000) {
      number = number / 100;
    }

    return '$' + number.toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  var citywideSuggestionPaths = [
    {
      title: 'Printer consumables',
      url: '/search?type=product&q=*&filter.p.tag=collection%3APrinter%20Consumables',
      meta: 'Category',
      keywords: 'printer consumables toner ink cartridge drum brother hp canon epson kyocera oki',
    },
    {
      title: 'Toner & drums',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AToner%20%26%20Drums',
      meta: 'Category',
      keywords: 'toner drum cartridge laser printer brother hp canon kyocera oki',
    },
    {
      title: 'Ink cartridges',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AInk%20Cartridges',
      meta: 'Category',
      keywords: 'ink cartridge colour black brother hp canon epson printer',
    },
    {
      title: 'Labels & printer media',
      url: '/search?type=product&q=*&filter.p.tag=collection%3ALabels%20%26%20Printer%20Media',
      meta: 'Category',
      keywords: 'labels label printer media paper receipt roll ribbon thermal sheets',
    },
    {
      title: 'Printers',
      url: '/search?type=product&q=*&filter.p.tag=collection%3APrinters',
      meta: 'Category',
      keywords: 'printer laser inkjet multifunction brother hp canon epson',
    },
    {
      title: 'Networking & Wi-Fi',
      url: '/search?type=product&q=*&filter.p.tag=collection%3ANetworking%20%26%20Wi-Fi',
      meta: 'Category',
      keywords: 'network networking wifi wi-fi router switch tp-link range extender mesh cable',
    },
    {
      title: 'Cables & adapters',
      url: '/search?type=product&q=*&filter.p.tag=collection%3ACables%20Hubs%20%26%20Adapters',
      meta: 'Category',
      keywords: 'cable adapter usb hdmi displayport type-c dvi ethernet',
    },
    {
      title: 'Keyboards & peripherals',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AKeyboards%20%26%20Mice',
      meta: 'Category',
      keywords: 'keyboard mouse mice peripherals headset webcam desktop typing',
    },
    {
      title: 'Accessories',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AAccessories',
      meta: 'Category',
      keywords: 'accessories stand hub webcam headset desk office tech add ons',
    },
    {
      title: 'Audio visual & monitors',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AAudio%20Visual%20%26%20Monitors',
      meta: 'Category',
      keywords: 'audio visual monitor monitors display screen speaker webcam conference hdmi projector',
    },
    {
      title: 'PC components & storage',
      url: '/search?type=product&q=*&filter.p.tag=collection%3APC%20Components%20%26%20Storage',
      meta: 'Category',
      keywords: 'pc components storage ssd nvme ram memory drive hard disk enclosure',
    },
    {
      title: 'Power & charging',
      url: '/search?type=product&q=*&filter.p.tag=collection%3APower%20%26%20Charging',
      meta: 'Category',
      keywords: 'power charging charger powerbank power bank surge board usb-c laptop adapter',
    },
    {
      title: 'Surveillance & security',
      url: '/search?type=product&q=*&filter.p.tag=collection%3ASurveillance%20%26%20Security',
      meta: 'Category',
      keywords: 'surveillance security camera cameras cctv nvr recorder network security',
    },
    {
      title: 'Apple & mobile accessories',
      url: '/search?type=product&q=*&filter.p.tag=collection%3AApple%20%26%20Mobile%20Accessories',
      meta: 'Category',
      keywords: 'apple mobile phone tablet iphone ipad case charger earbuds cable magsafe',
    },
  ];

  var citywideBrandSuggestions = ['Apple', 'Brother', 'Canon', 'HP', 'mbeat', 'Mercusys', 'OKI', 'SilverStone', 'TP-Link', 'Vention'].map(function (brand) {
    return {
      title: brand,
      url: '/search?type=product&q=*&filter.p.vendor=' + encodeURIComponent(brand),
      meta: 'Brand',
      keywords: brand.toLowerCase(),
    };
  });

  function matchingSuggestions(query, items, limit) {
    var normalizedQuery = query.toLowerCase();
    var queryParts = normalizedQuery.split(/\s+/).filter(function (part) {
      return part.length >= 2;
    });
    var matches = items.filter(function (item) {
      var itemTokens = (item.title + ' ' + item.keywords).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

      return queryParts.every(function (part) {
        return itemTokens.some(function (token) {
          return token === part || token.startsWith(part);
        });
      });
    });

    if (matches.length === 0 && normalizedQuery.length >= 3) {
      matches = items.filter(function (item) {
        var itemTokens = item.keywords.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

        return queryParts.some(function (part) {
          return part.length >= 3 && itemTokens.some(function (token) {
            return token === part || token.startsWith(part);
          });
        });
      });
    }

    return matches.slice(0, limit);
  }

  function titleFromTag(value) {
    return String(value || '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  function categoryUrl(title) {
    var normalizedTitle = titleFromTag(title);
    var knownCollectionTags = {
      'printer consumables': 'Printer Consumables',
      'toner & drums': 'Toner & Drums',
      'ink cartridges': 'Ink Cartridges',
      'labels & printer media': 'Labels & Printer Media',
      'printers': 'Printers',
      'networking & wi-fi': 'Networking & Wi-Fi',
      'cables hubs & adapters': 'Cables Hubs & Adapters',
      'cables & adapters': 'Cables Hubs & Adapters',
      'keyboards & mice': 'Keyboards & Mice',
      'keyboards & peripherals': 'Keyboards & Mice',
      'accessories': 'Accessories',
      'audio visual & monitors': 'Audio Visual & Monitors',
      'pc components & storage': 'PC Components & Storage',
      'power & charging': 'Power & Charging',
      'surveillance & security': 'Surveillance & Security',
      'apple & mobile accessories': 'Apple & Mobile Accessories',
    };
    var collectionTag = knownCollectionTags[normalizedTitle.toLowerCase()];

    if (collectionTag) {
      return '/search?type=product&q=*&filter.p.tag=' + encodeURIComponent('collection:' + collectionTag);
    }

    return '/search?type=product&q=' + encodeURIComponent(String(title || '').toLowerCase());
  }

  function pushInferredCategory(map, title, query, weight) {
    var cleanTitle = titleFromTag(title);

    if (!cleanTitle || cleanTitle.length < 3) {
      return;
    }

    var key = cleanTitle.toLowerCase();
    var current = map[key] || {
      title: cleanTitle,
      url: categoryUrl(cleanTitle),
      meta: '0 matches',
      keywords: cleanTitle.toLowerCase(),
      count: 0,
      weight: 0,
    };

    current.count += 1;
    current.weight += weight || 1;
    current.meta = current.count === 1 ? '1 match' : current.count + ' matches';

    if (query && cleanTitle.toLowerCase().includes(query.toLowerCase())) {
      current.weight += 2;
    }

    map[key] = current;
  }

  function inferredCategoriesFromProducts(query, products, limit) {
    var map = {};

    (products || []).forEach(function (product) {
      (product.tags || []).forEach(function (tag) {
        if (tag.indexOf('collection:') === 0) {
          pushInferredCategory(map, tag.replace('collection:', ''), query, 4);
        } else if (tag.indexOf('category:') === 0) {
          pushInferredCategory(map, tag.replace('category:', ''), query, 3);
        } else if (tag.indexOf('type:') === 0) {
          pushInferredCategory(map, tag.replace('type:', ''), query, 2);
        }
      });

      if (product.type) {
        pushInferredCategory(map, product.type, query, 2);
      }

      if (product.vendor) {
        pushInferredCategory(map, product.vendor, query, 1);
      }

      if (product.title && /airtag/i.test(product.title)) {
        pushInferredCategory(map, 'AirTag accessories', query, 5);
      }

      if (product.title && /macbook air/i.test(product.title)) {
        pushInferredCategory(map, 'MacBook Air accessories', query, 5);
      }
    });

    return Object.keys(map)
      .map(function (key) {
        return map[key];
      })
      .sort(function (a, b) {
        return b.weight - a.weight || b.count - a.count || a.title.localeCompare(b.title);
      })
      .slice(0, limit || 4);
  }

  function suggestionItem(resource, type) {
    var url = escapeHtml(resource.url || '#');
    var title = escapeHtml(resource.title || resource.text || '');
    var image = resource.featured_image && (resource.featured_image.url || resource.featured_image);
    var price = resource.price_min || resource.price;
    var media = image ? '<img src="' + escapeHtml(image) + '" alt="">' : '<span class="cwt-shop-search-suggestions__placeholder"></span>';
    var meta = escapeHtml(resource.meta || (type === 'product' ? resource.vendor || resource.type || '' : 'Category'));
    var priceText = type === 'product' && price ? '<strong>' + formatMoney(price) + '</strong>' : '';

    var fallbackMeta = type === 'collection' ? 'Category' : 'Product';
    var detail = meta || fallbackMeta;

    return [
      '<a class="cwt-shop-search-suggestions__item cwt-shop-search-suggestions__item--' + type + '" href="' + url + '">',
      media,
      '<span><b>' + title + '</b><small>' + escapeHtml(detail) + '</small></span>',
      priceText,
      '</a>',
    ].join('');
  }

  function renderSearchSuggestions(form, query, data) {
    var panel = form.querySelector('.cwt-shop-search-suggestions');

    if (!panel) {
      return;
    }

    var resources = data && data.resources && data.resources.results ? data.resources.results : {};
    var collections = (resources.collections || []).slice(0, 3);
    var categorySuggestions = matchingSuggestions(query, citywideSuggestionPaths, 4);
    var brandSuggestions = matchingSuggestions(query, citywideBrandSuggestions, 3);
    var products = (resources.products || []).slice();
    var inferredCategories = inferredCategoriesFromProducts(query, products, 5);
    var html = [];

    if (products.length) {
      html.push('<div class="cwt-shop-search-suggestions__group"><p>Products</p>');
      html.push(products.slice(0, 5).map(function (item) {
        return suggestionItem(item, 'product');
      }).join(''));
      html.push('</div>');

      if (query) {
        var productSearchUrl = window.CitywideSearchQueries
          ? window.CitywideSearchQueries.searchResultsUrl(query)
          : '/search?type=product&q=' + encodeURIComponent(query);
        html.push('<a class="cwt-shop-search-suggestions__all" href="' + escapeHtml(productSearchUrl) + '">See all products for "' + escapeHtml(query) + '"</a>');
      }
    } else {
      categorySuggestions.forEach(function (item) {
        if (!collections.some(function (collection) {
          return collection.title && collection.title.toLowerCase() === item.title.toLowerCase();
        })) {
          collections.push(item);
        }
      });

      inferredCategories.forEach(function (item) {
        if (!collections.some(function (collection) {
          return collection.title && collection.title.toLowerCase() === item.title.toLowerCase();
        })) {
          collections.push(item);
        }
      });

      if (collections.length) {
        html.push('<div class="cwt-shop-search-suggestions__group"><p>Categories</p>');
        html.push(collections.slice(0, 4).map(function (item) {
          return suggestionItem(item, 'collection');
        }).join(''));
        html.push('</div>');
      }

      if (brandSuggestions.length) {
        html.push('<div class="cwt-shop-search-suggestions__group"><p>Brands</p>');
        html.push(brandSuggestions.map(function (item) {
          return suggestionItem(item, 'collection');
        }).join(''));
        html.push('</div>');
      }

      if (query) {
        var fallbackSearchUrl = window.CitywideSearchQueries
          ? window.CitywideSearchQueries.searchResultsUrl(query)
          : '/search?type=product&q=' + encodeURIComponent(query);
        html.push('<a class="cwt-shop-search-suggestions__all" href="' + escapeHtml(fallbackSearchUrl) + '">Search products for "' + escapeHtml(query) + '"</a>');
      }
    }

    panel.innerHTML = html.join('');
    panel.hidden = html.length === 0;
  }

  function watchCitywideHeaderSearch() {
    var originalSearchQuery = '';
    try {
      originalSearchQuery = window.CitywideSearchQueries
        ? window.CitywideSearchQueries.originalSearchQuery(window.location.search)
        : '';
    } catch (error) {
      originalSearchQuery = '';
    }

    document.querySelectorAll('.cwt-shop-search').forEach(function (form) {
      if (form.dataset.citywidePredictive === 'true') {
        return;
      }

      var input = form.querySelector('input[name="q"]');
      var panel = form.querySelector('.cwt-shop-search-suggestions');
      var reset = form.querySelector('.cwt-shop-search__reset');
      var timeout;
      var controller;

      if (!input || !panel) {
        return;
      }

      form.dataset.citywidePredictive = 'true';

      if (originalSearchQuery) {
        input.value = originalSearchQuery;
      }

      form.addEventListener('submit', function () {
        if (!window.CitywideSearchQueries) {
          return;
        }

        var originalQuery = input.value.trim();
        var submittedQuery = window.CitywideSearchQueries.submittedSearchQuery(originalQuery);
        if (!originalQuery || submittedQuery === originalQuery) {
          return;
        }

        var originalField = form.querySelector('input[name="cwt_query"]');
        if (!originalField) {
          originalField = document.createElement('input');
          originalField.type = 'hidden';
          originalField.name = 'cwt_query';
          form.appendChild(originalField);
        }
        originalField.value = originalQuery;
        input.value = submittedQuery;
      });

      function updateResetState() {
        if (reset) {
          reset.hidden = input.value.trim().length === 0;
        }
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        window.clearTimeout(timeout);
        updateResetState();

        if (controller) {
          controller.abort();
        }

        if (query.length < 2) {
          panel.hidden = true;
          panel.innerHTML = '';
          return;
        }

        timeout = window.setTimeout(function () {
          controller = new AbortController();
          var searchRequests = window.CitywideSearchQueries
            ? window.CitywideSearchQueries.predictiveSearchRequests(query)
            : [{
              kind: 'catalogue',
              url: '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=10',
            }];
          Promise.all(searchRequests.map(function (request) {
            return fetch(request.url, {
              signal: controller.signal,
            }).then(function (response) {
              return response.ok ? response.json() : null;
            }).then(function (data) {
              return { kind: request.kind, data: data };
            }).catch(function (error) {
              if (error && error.name === 'AbortError') {
                throw error;
              }
              return { kind: request.kind, data: null };
            });
          }))
            .then(function (responses) {
              var data = window.CitywideSearchQueries
                ? window.CitywideSearchQueries.mergePredictiveSearchResponses(query, responses)
                : responses[0].data;
              if (data) {
                renderSearchSuggestions(form, query, data);
              }
            })
            .catch(function (error) {
              if (error && error.name !== 'AbortError') {
                panel.hidden = true;
              }
            });
        }, 160);
      });

      input.addEventListener('focus', function () {
        updateResetState();
        if (panel.innerHTML.trim()) {
          panel.hidden = false;
        }
      });

      if (reset) {
        reset.addEventListener('click', function () {
          input.value = '';
          panel.hidden = true;
          panel.innerHTML = '';
          updateResetState();
          input.focus();
        });
      }

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
          panel.hidden = true;
        }
      });
    });
  }

  function cleanLiteralDescriptionBreaks() {
    document.querySelectorAll('.product-description, .product-details, .rte').forEach(function (container) {
      if (container.dataset.citywideBreaksCleaned === 'true') {
        return;
      }

      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      var textNode = walker.nextNode();

      while (textNode) {
        if (textNode.nodeValue && textNode.nodeValue.includes('\\n')) {
          textNode.nodeValue = textNode.nodeValue.replace(/\s*\\n\s*/g, ' ');
        }

        textNode = walker.nextNode();
      }

      container.dataset.citywideBreaksCleaned = 'true';
    });
  }

  function hideEmptyPaymentButtons() {
    document.querySelectorAll('.shopify-payment-button').forEach(function (container) {
      var visibleText = (container.textContent || '').replace(/\u00a0/g, '').trim();
      var hasInteractivePayment = container.querySelector('iframe, button, [role="button"]');

      if (!visibleText && !hasInteractivePayment) {
        container.hidden = true;
      }
    });
  }

  function positionSearchResultControls() {
    var layout = document.querySelector('.cwt-search-results-layout');

    if (!layout) {
      return;
    }

    var sidebar = layout.querySelector('.cwt-search-sidebar');
    var controls = layout.querySelector('.facets--horizontal.facets-controls-wrapper');

    if (!sidebar || !controls) {
      return;
    }

    if (controls.dataset.citywideSearchControls !== 'placed') {
      controls.dataset.citywideSearchControls = 'placed';
      controls.classList.add('cwt-search-result-controls');

      if (sidebar.contains(controls)) {
        sidebar.insertAdjacentElement('afterend', controls);
      }
    }

    if (window.matchMedia('(min-width: 990px)').matches) {
      var grid = layout.querySelector('#ResultsList');

      layout.style.setProperty('display', 'grid', 'important');
      layout.style.setProperty('grid-template-columns', '248px minmax(0, 1fr)', 'important');
      layout.style.setProperty('column-gap', '26px', 'important');
      layout.style.setProperty('row-gap', '0', 'important');
      layout.style.setProperty('align-items', 'start', 'important');

      sidebar.style.setProperty('grid-column', '1', 'important');
      sidebar.style.setProperty('grid-row', '2 / span 2', 'important');
      sidebar.style.setProperty('width', '248px', 'important');
      sidebar.style.setProperty('max-width', '248px', 'important');
      sidebar.style.setProperty('max-height', 'calc(100vh - 104px)', 'important');
      sidebar.style.setProperty('overflow-x', 'hidden', 'important');
      sidebar.style.setProperty('overflow-y', 'auto', 'important');

      controls.style.setProperty('grid-column', '2', 'important');
      controls.style.setProperty('grid-row', '2', 'important');
      controls.style.setProperty('position', 'relative', 'important');
      controls.style.setProperty('inset', 'auto', 'important');
      controls.style.setProperty('width', '100%', 'important');
      controls.style.setProperty('max-width', '100%', 'important');
      controls.style.setProperty('margin', '0', 'important');
      controls.style.setProperty('z-index', '6200', 'important');

      if (grid) {
        grid.style.setProperty('grid-column', '2', 'important');
        grid.style.setProperty('grid-row', '3', 'important');
        grid.style.setProperty('width', '100%', 'important');
        grid.style.setProperty('max-width', '100%', 'important');
        grid.style.setProperty('margin', '0', 'important');
      }

      updateSearchSidebarViewportHeight();
    } else {
      var mobileGrid = layout.querySelector('#ResultsList');
      var layoutProps = ['display', 'grid-template-columns', 'column-gap', 'row-gap', 'align-items'];
      var sidebarProps = ['grid-column', 'grid-row', 'width', 'max-width', 'max-height', 'overflow-x', 'overflow-y'];
      var controlsProps = ['grid-column', 'grid-row', 'position', 'inset', 'width', 'max-width', 'margin', 'z-index'];
      var gridProps = ['grid-column', 'grid-row', 'width', 'max-width', 'margin'];

      layoutProps.forEach(function (prop) {
        layout.style.removeProperty(prop);
      });

      sidebarProps.forEach(function (prop) {
        sidebar.style.removeProperty(prop);
      });

      controlsProps.forEach(function (prop) {
        controls.style.removeProperty(prop);
      });

      if (mobileGrid) {
        gridProps.forEach(function (prop) {
          mobileGrid.style.removeProperty(prop);
        });
      }
    }
  }

  window.citywidePositionSearchResultControls = positionSearchResultControls;

  if (document.readyState === 'loading') {
    routeAllProductsToSearch();

    document.addEventListener('DOMContentLoaded', function () {
      storeCurrentCatalogLocation();
      patchContinueShoppingLink();
      watchCatalogProductLinks();
      patchLocalWebsiteLinks();
      patchFooter();
      watchCitywideCartCount();
      watchCitywideHeaderSearch();
      positionSearchResultControls();
      trapDesktopSidebarWheel();
      updateSearchSidebarViewportHeight();
      labelCitywideAddButtons();
      cleanLiteralDescriptionBreaks();
      hideEmptyPaymentButtons();
    });
  } else {
    routeAllProductsToSearch();
    storeCurrentCatalogLocation();
    patchContinueShoppingLink();
    watchCatalogProductLinks();
    patchLocalWebsiteLinks();
    patchFooter();
    watchCitywideCartCount();
    watchCitywideHeaderSearch();
    positionSearchResultControls();
    trapDesktopSidebarWheel();
    updateSearchSidebarViewportHeight();
    labelCitywideAddButtons();
    cleanLiteralDescriptionBreaks();
    hideEmptyPaymentButtons();
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(window.citywideSearchLayoutTimer);
    window.citywideSearchLayoutTimer = window.setTimeout(function () {
      positionSearchResultControls();
      trapDesktopSidebarWheel();
      updateSearchSidebarViewportHeight();
    }, 120);
  });

  window.addEventListener('scroll', scheduleSearchSidebarViewportHeight, { passive: true });
})();
